import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export enum ChipColor {
  PRIMARY = 'text-primary-500 border-gray-300 bg-gray-100',
  SECONDARY = 'text-secondary-500 border-secondary-300 bg-secondary-100',
  SUCCESS = 'text-green-700 border-green-300 bg-green-100',
  DANGER = 'text-red-700 border-red-300 bg-pink-100',
  WARNING = 'text-yellow-700 border-yellow-300 bg-yellow-100',
  INFO = 'text-blue-500 border-blue-300 bg-blue-100',
  LIGHT = 'text-primary-500 border-gray-200 bg-white',
  DARK = 'text-white border-primary-500 bg-primary-200',
}

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.css',
})
export class ChipComponent {
  @Input() label: string = '';
  @Input() color: ChipColor = ChipColor.PRIMARY;
  @Input() prefixIcon: string = '';
  @Input() padding: string = 'px-2.5 py-1';
  @Input() fontSize: string = 'text-[10px] sm:text-xs';
}
